module.exports = __webpack_public_path__ + "7f930a644786a36c413944816a31935b.png";